<template>
  <div class="header" @mouseleave="handemouseleave">
    <div class="logo"></div>
    <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect">
      <el-menu-item
        v-for="item in menuList"
        :key="item.id"
        :index="item.index"
        @mouseenter.native="overShow(item.index)"
        @mouseleave.native="outHide(item.index)"
        >{{ item.title }}
        <!-- 导航 -->
        <headerNav v-if="item.index.indexOf('/') === -1 && showIndex === item.index" :showIndex="showIndex" />
      </el-menu-item>
      <el-button type="primary" class="elButton" @click="connect">联系我们</el-button>
    </el-menu>
  </div>
</template>
<script>
import headerNav from './nav.vue'
export default {
  name: 'Header',
  components: { headerNav },
  props: {},
  data() {
    return {
      activeIndex: '/',
      showIndex: '',
      menuList: [
        { id: '1', index: '/', title: '首页' },
        { id: '2', index: '2', title: '产品中心' },
        { id: '3', index: '3', title: '定制服务' },
        { id: '4', index: '4', title: '解决方案' },
        { id: '5', index: '/introduce', title: '关于我们' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    window.addEventListener('scroll', this.scrollToTop)
  },
  activated() {},
  methods: {
    scrollToTop() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const logoImg = require('../../assets/img/app/logo.png')
      const logoImg1 = require('../../assets/img/app/logo1.png')
      if (scrollTop) {
        document.querySelector('.header').style.background = '#ffffff'
        document.querySelectorAll('.header .el-menu-item').forEach(e => {
          e.style.color = '#181818'
        })
        document.querySelector('.header .logo').style.backgroundImage = "url('" + logoImg + "')"
      } else {
        document.querySelector('.header').style.background = 'transparent'
        document.querySelectorAll('.header .el-menu-item').forEach(e => {
          e.style.color = '#ffffff'
        })
        document.querySelector('.header .logo').style.backgroundImage = "url('" + logoImg1 + "')"
      }
    },
    handleSelect(key) {
      if (key.indexOf('/') != -1) {
        this.$router.push(key)
      }
    },
    overShow(index) {
      this.showIndex = index
    },
    outHide(index) {
      this.showIndex = index
    },
    handemouseleave() {
      this.showIndex = ''
    },
    connect() {
      this.$router.push({name:'aboutUs'})
    },
  },
}
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding: 0 60px;
  width: 100vw;
  position: relative;
  background-color: transparent;
  &:hover {
    background: #ffffff !important;
    .el-menu-item {
      color: #181818 !important;
    }
    .logo {
      background-image: url('../../assets/img/app/logo.png') !important;
    }
  }
  .logo {
    width: 77px;
    margin: 10px;
    height: auto;
    background-image: url('../../assets/img/app/logo1.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
.el-menu {
  border-bottom: none !important;
  background-color: transparent !important;
  .el-menu-item {
    font-size: 18px;
    color: #ffffff;
    font-family: Microsoft YaHei !important;
    margin-right: 40px !important;
    margin-left: 20px !important;
    padding: 0px !important;
    // color: #181818 !important;
    border-bottom: none !important;
  }
  .el-menu-item:hover {
    background-color: transparent !important;
    border-bottom: 2px solid #409eff !important;
    color: #2093ff !important;
  }
  .el-menu-item.is-active {
    color: #2093ff !important;
    border-bottom: none !important;
  }
  .el-menu-item.is-active:hover {
    background-color: transparent !important;
  }
  .el-menu-item.is-active:focus {
    background-color: transparent !important;
  }
  .elButton {
    width: 100px;
    height: 40px;
    margin: 10px 40px 0 50px;
  }
}
</style>
